import { render } from "./Friends.vue?vue&type=template&id=228f7a2a&scoped=true"
import script from "./Friends.vue?vue&type=script&lang=js"
export * from "./Friends.vue?vue&type=script&lang=js"

import "./Friends.vue?vue&type=style&index=0&id=228f7a2a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228f7a2a"]])

export default __exports__